/*eslint-disable */
import React from "react";
interface AsistenciaComponentProps {
  assistances: any;
}
const AsistenciaComponent: React.FC<AsistenciaComponentProps> = ({
  assistances,
}) => {
  return (
    <>
      {/* <div className="title-posventa-asistecia-component">Asistencia</div> */}
      <div className="servicios-posventa-asistecia-container">
        {assistances?.map((item: any, index: number) => (
          <div
            key={index}
            className={`contenido-servicios-posventa-asistecia-container ${item?.format === "left" ? "anormal" : ""}`}
          >
            <div className="img-contenido-servicios-posventa-asistecia-container">
              <img 
                src={`https://manager.hyundaicolombia.co/${item?.media?.url}`} 
                alt={item?.title ? item.title : "Imagen de asistencia"} 
              />
            </div>
            <div className="text-contenido-servicios-posventa-asistecia-container">
              <div className="title">{item?.title}</div>
              <div className="description" dangerouslySetInnerHTML={{ __html: item?.description }}>
              </div>
              {/* <div className="btn">Ver más</div> */}
            </div>
          </div>
        ))}
      </div>
    </>
  );
};
export default AsistenciaComponent;
